<template>
  <Primitive
    data-slot="button"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ color, iconOnly, size, variant }), props.class)"
  >
    <slot />
  </Primitive>
</template>

<script setup lang="ts">
import { Primitive, type PrimitiveProps } from "reka-ui";
import type { HTMLAttributes } from "vue";
import { type ButtonVariants, buttonVariants } from "./variants";
import { cn } from "@/lib/utils";

interface Props extends PrimitiveProps {
  color?: ButtonVariants["color"];
  iconOnly?: boolean;
  variant?: ButtonVariants["variant"];
  size?: ButtonVariants["size"];
  class?: HTMLAttributes["class"];
}

const props = withDefaults(defineProps<Props>(), {
  as: "button",
  color: "primary",
  iconOnly: false,
  variant: "solid",
  class: "",
  size: "md",
});
</script>
